/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespLayout_viewer = {
    readonly itemSearch: {
        readonly pageType: string | null;
        readonly displayUriRef: string | null;
        readonly " $fragmentRefs": FragmentRefs<"useSearchCorrections_itemSearch" | "SbSharedRefetchContainer_itemSearch" | "SbSharedTrackingContainer_itemSearch" | "SbSharedHead_itemSearch" | "SbRespComponents_itemSearch">;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"SbSharedTrackingContainer_user" | "SbRespComponents_user">;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_regionalInfo">;
    } | null> | null;
    readonly shippingFilters?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_shippingFilters" | "SbRespComponents_shippingFilters">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_viewer">;
    readonly " $refType": "SbRespLayout_viewer";
};
export type SbRespLayout_viewer$data = SbRespLayout_viewer;
export type SbRespLayout_viewer$key = {
    readonly " $data"?: SbRespLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v1 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v2 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "disableForceFacet"
    },
    {
      "kind": "RootArgument",
      "name": "disableNonParameterizedUrlRedirects"
    },
    {
      "kind": "RootArgument",
      "name": "eligibleAbTest"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSb"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasPersonalizedFilter"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "regions"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "disableForceFacet",
          "variableName": "disableForceFacet"
        },
        {
          "kind": "Variable",
          "name": "disableNonParameterizedUrlRedirects",
          "variableName": "disableNonParameterizedUrlRedirects"
        },
        {
          "kind": "Variable",
          "name": "eligibleAbTest",
          "variableName": "eligibleAbTest"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "regions",
          "variableName": "regions"
        },
        (v0/*: any*/)
      ],
      "concreteType": "ItemSearchQueryConnection",
      "kind": "LinkedField",
      "name": "itemSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUriRef",
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "useSearchCorrections_itemSearch",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchCorrectionsType",
              "kind": "LinkedField",
              "name": "searchCorrections",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "semanticSearchTerm",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "classificationLevel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "classificationSearchTerm",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParam",
              "kind": "LinkedField",
              "name": "appliedFilters",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SearchBrowseParsedParamValue",
                  "kind": "LinkedField",
                  "name": "values",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urlLabel",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRefetchContainer_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedTrackingContainer_itemSearch"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedHead_itemSearch"
        },
        {
          "condition": "fetchSb",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespComponents_itemSearch"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespComponents_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespComponents_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_regionalInfo"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasPersonalizedFilter",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*: any*/),
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "concreteType": "ShippingFilterType",
          "kind": "LinkedField",
          "name": "shippingFilters",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_shippingFilters"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbRespComponents_shippingFilters"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = 'b1aca151d2703019e05bb3fb73cd56ec';
export default node;
